/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentScopeEnum } from './DocumentScopeEnum';
import {
    DocumentScopeEnumFromJSON,
    DocumentScopeEnumFromJSONTyped,
    DocumentScopeEnumToJSON,
    DocumentScopeEnumToJSONTyped,
} from './DocumentScopeEnum';
import type { FilterPeriodDto } from './FilterPeriodDto';
import {
    FilterPeriodDtoFromJSON,
    FilterPeriodDtoFromJSONTyped,
    FilterPeriodDtoToJSON,
    FilterPeriodDtoToJSONTyped,
} from './FilterPeriodDto';

/**
 * 
 * @export
 * @interface FiltersDto
 */
export interface FiltersDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    productIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    statuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    priorities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    owners?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    personIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    contractIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    riskIds?: Array<string>;
    /**
     * 
     * @type {FilterPeriodDto}
     * @memberof FiltersDto
     */
    period?: FilterPeriodDto;
    /**
     * 
     * @type {string}
     * @memberof FiltersDto
     */
    plateformeId?: string;
    /**
     * Filter by plateformes (used by funnels and others to scope by plateforme)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    plateformeIds?: Array<string>;
    /**
     * Filter by brokers (admin list routes). brokerIds alone (without plateformeIds) returns all the broker's records, even across multiple plateformes
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    brokerIds?: Array<string>;
    /**
     * Filter by branches (simulations/devis/contrats/clients lists)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    branchIds?: Array<string>;
    /**
     * Filtre par partenaire apporteur (facette partnerPlateformes) — liste des leads externes uniquement
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    partnerPlateformeIds?: Array<string>;
    /**
     * Filter simulations by provenance (facette simulationSource)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    sourceIds?: Array<string>;
    /**
     * Filter by active status ids (facette active — tunnels / produits)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    active?: Array<string>;
    /**
     * Filter prélèvements by withdrawal mode (facette withdrawalModes)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    withdrawalModes?: Array<string>;
    /**
     * Filter prélèvements by aggregated state (facette paymentStates)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    paymentStates?: Array<string>;
    /**
     * Filter clients by person type. Guid figés : personne physique 11111111-1111-1111-1111-111111111111, personne morale 22222222-2222-2222-2222-222222222222 (renvoyés par la facette personTypes)
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    personTypeIds?: Array<string>;
    /**
     * Filter courtiers by intermediary category
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    categoryIds?: Array<string>;
    /**
     * Filter courtiers by active status. Guid figés : actif 33333333-3333-3333-3333-333333333333, inactif 44444444-4444-4444-4444-444444444444 (renvoyés par la facette active)
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    activeStatusIds?: Array<string>;
    /**
     * Filter by tunnels (simulations/devis/contrats lists)
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    tunnelIds?: Array<string>;
    /**
     * Filter funnels by type: 1 = Individual, 2 = Collective
     * @type {number}
     * @memberof FiltersDto
     */
    typeTunnel?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FiltersDto
     */
    isActive?: boolean;
    /**
     * Listes admin (contrats, devis, simulations, clients, courtiers, prélèvements) : inclure la plateforme de test (Confiancia Testing). absent/false = exclue de la liste, du totalCount et de TOUTES les facettes (défaut, ne rien envoyer suffit) ; true = tout est remonté, orga de test comprise. Propagé au body des routes /admin/liste, /admin/liste/filtres et /admin/liste/csv. Remplace l'ancien filtre tri-état isTest des prélèvements (breaking).
     * 
     * @type {boolean}
     * @memberof FiltersDto
     */
    includeTests?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FiltersDto
     */
    groupContractIds?: Array<string>;
    /**
     * 
     * @type {Array<DocumentScopeEnum>}
     * @memberof FiltersDto
     */
    scopes?: Array<DocumentScopeEnum>;
    /**
     * 
     * @type {string}
     * @memberof FiltersDto
     */
    riskId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FiltersDto
     */
    isCompleted?: boolean;
}

/**
 * Check if a given object implements the FiltersDto interface.
 */
export function instanceOfFiltersDto(value: object): value is FiltersDto {
    return true;
}

export function FiltersDtoFromJSON(json: any): FiltersDto {
    return FiltersDtoFromJSONTyped(json, false);
}

export function FiltersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FiltersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'productIds': json['productIds'] == null ? undefined : json['productIds'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'priorities': json['priorities'] == null ? undefined : json['priorities'],
        'owners': json['owners'] == null ? undefined : json['owners'],
        'personIds': json['personIds'] == null ? undefined : json['personIds'],
        'contractIds': json['contractIds'] == null ? undefined : json['contractIds'],
        'riskIds': json['riskIds'] == null ? undefined : json['riskIds'],
        'period': json['period'] == null ? undefined : FilterPeriodDtoFromJSON(json['period']),
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'plateformeIds': json['plateformeIds'] == null ? undefined : json['plateformeIds'],
        'brokerIds': json['brokerIds'] == null ? undefined : json['brokerIds'],
        'branchIds': json['branchIds'] == null ? undefined : json['branchIds'],
        'partnerPlateformeIds': json['partnerPlateformeIds'] == null ? undefined : json['partnerPlateformeIds'],
        'sourceIds': json['sourceIds'] == null ? undefined : json['sourceIds'],
        'active': json['active'] == null ? undefined : json['active'],
        'withdrawalModes': json['withdrawalModes'] == null ? undefined : json['withdrawalModes'],
        'paymentStates': json['paymentStates'] == null ? undefined : json['paymentStates'],
        'personTypeIds': json['personTypeIds'] == null ? undefined : json['personTypeIds'],
        'categoryIds': json['categoryIds'] == null ? undefined : json['categoryIds'],
        'activeStatusIds': json['activeStatusIds'] == null ? undefined : json['activeStatusIds'],
        'tunnelIds': json['tunnelIds'] == null ? undefined : json['tunnelIds'],
        'typeTunnel': json['typeTunnel'] == null ? undefined : json['typeTunnel'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'includeTests': json['includeTests'] == null ? undefined : json['includeTests'],
        'groupContractIds': json['groupContractIds'] == null ? undefined : json['groupContractIds'],
        'scopes': json['scopes'] == null ? undefined : ((json['scopes'] as Array<any>).map(DocumentScopeEnumFromJSON)),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'isCompleted': json['isCompleted'] == null ? undefined : json['isCompleted'],
    };
}

export function FiltersDtoToJSON(json: any): FiltersDto {
    return FiltersDtoToJSONTyped(json, false);
}

export function FiltersDtoToJSONTyped(value?: FiltersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productIds': value['productIds'],
        'statuses': value['statuses'],
        'priorities': value['priorities'],
        'owners': value['owners'],
        'personIds': value['personIds'],
        'contractIds': value['contractIds'],
        'riskIds': value['riskIds'],
        'period': FilterPeriodDtoToJSON(value['period']),
        'plateformeId': value['plateformeId'],
        'plateformeIds': value['plateformeIds'],
        'brokerIds': value['brokerIds'],
        'branchIds': value['branchIds'],
        'partnerPlateformeIds': value['partnerPlateformeIds'],
        'sourceIds': value['sourceIds'],
        'active': value['active'],
        'withdrawalModes': value['withdrawalModes'],
        'paymentStates': value['paymentStates'],
        'personTypeIds': value['personTypeIds'],
        'categoryIds': value['categoryIds'],
        'activeStatusIds': value['activeStatusIds'],
        'tunnelIds': value['tunnelIds'],
        'typeTunnel': value['typeTunnel'],
        'isActive': value['isActive'],
        'includeTests': value['includeTests'],
        'groupContractIds': value['groupContractIds'],
        'scopes': value['scopes'] == null ? undefined : ((value['scopes'] as Array<any>).map(DocumentScopeEnumToJSON)),
        'riskId': value['riskId'],
        'isCompleted': value['isCompleted'],
    };
}

